import { Col, Container, Row } from 'react-bootstrap'
import { ArrowRightCircle } from 'react-bootstrap-icons'
import headerImg from "../assets/img/header-img.svg"
import { useState, useEffect } from 'react'
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const Banner = () => {

    const [loopNum, setLoopNum] = useState(0);
    const [isdeleting, setIsdeleting] = useState(false);
    const toRotate = ["Full Stack Web Developer", "Software Engineer"]
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);

    const period = 1000;





    const tick = () => {
        let i = loopNum % toRotate.length;
        let fulltext = toRotate[i];
        let updatedText = isdeleting ? fulltext.substring(0, text.length - 1) : fulltext.substring(0, text.length + 1);

        setText(updatedText);

        if (!isdeleting) {
            setDelta(prevDelta => prevDelta / 2)
        }

        if (!isdeleting && updatedText === fulltext) {
            setIsdeleting(true);
            setDelta(period);
        } else if (isdeleting && updatedText === '') {
            setIsdeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500)
        }

    }

    const handleEmailClick = () => {
        const email = 'akshayshrivastava1702@gmail.com';
        const subject = encodeURIComponent("Akshay let's Connect from your portfolio");
        const body = encodeURIComponent(`Hi [Your Name],\n\n` +
            `I hope you’re doing well.\n\n` +
            `I recently visited your portfolio website and was impressed by your work. I’m reaching out to discuss [specific project, collaboration opportunity, or inquiry].\n\n` +
            `Could you please provide more details or let me know the best way to get in touch?\n\n` +
            `Looking forward to hearing from you.\n\n` +
            `Best regards,\n` +
            `[Your Name]\n` +
            `[Your Contact Information, if applicable]`
);

        const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;

        window.location.href = mailtoLink;
    };

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);



        return () => { clearInterval(ticker) };
    }, [text])


    return (
        <section className="banner" id="home">
            <Container>
                <Row className="aligh-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                    <span className="tagline">Welcome to my Portfolio</span>
                                    <h1>{`Hi! I'm Akshay`} <span className="txt-rotate" dataperiod="1000" data-rotate='[ "Full Stack Web Developer", "Software Engineer", "ML Enthusiast" ]'><span className="wrap">{text}</span></span></h1>
                                    <p>Software engineer with a transformative approach, specializing in crafting efficient solutions, optimizing workflows, and pushing technological boundaries for impactful program execution and seamless user experiences.</p>
                                   
                                    <button onClick={handleEmailClick}>Let’s Connect <ArrowRightCircle size={25} /></button>
                                </div>}
                        </TrackVisibility>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                                    <img src={headerImg} alt="Header Img" />
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Banner